import { ScheduleItemV2 } from '@hopin-team/api-hopin/@types';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { Tag, TagProps } from '@hopin-team/ui-tag';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const eventAttendanceIcons: Record<
  NonNullable<ScheduleItemV2['attendance']>,
  { icon: TagProps['icon']; color: string }
> = {
  recommended: {
    icon: 'star' as TagProps['icon'],
    color: 'YELLOW',
  },
  optional: {
    icon: 'bulb' as TagProps['icon'],
    color: 'BLUE',
  },
};

export const EventAttendanceTag = styled(Tag)<{
  attendance: NonNullable<ScheduleItemV2['attendance']>;
}>`
  &[aria-pressed='true'] {
    color: ${({ attendance, theme }) =>
      getFromTheme(
        `COLOR.${eventAttendanceIcons[attendance].color}["500"]`,
        theme,
      )};
    background-color: ${({ attendance, theme }) =>
      getFromTheme(
        `COLOR.${eventAttendanceIcons[attendance].color}["100"]`,
        theme,
      )};
    border: none;
  }
  width: min-content;

  ${({ size }) =>
    size === 'tiny' &&
    css`
      height: ${rem(24)};
      font-size: ${rem(12)};
      & > div {
        margin-right: ${rem(6)};
      }
      & svg {
        height: ${rem(14)};
      }
    `}
`;
